module.exports = __webpack_public_path__ + "img/logo-magali.3303ca2a.png";